import { createFileRoute } from '@tanstack/react-router'
import { Insights } from '@/features/insights/Insights'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/insights')({
  component: InsightsPage,
})

function InsightsPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Insights" meta="Last 90 days" />
      <div className="mt-6">
        <Insights />
      </div>
    </div>
  )
}
